export default [
  {
    name: 'overview',
    label: 'Overview',
    hideOnNavbar: true,
    component: () => import('./Steps/OverviewStep'),
    navigation: {
      back: { label: 'Nevermind', to: null },
      next: { label: 'Next', to: 'experience' },
      skip: null,
    },
  },
  {
    name: 'experience',
    label: 'Experience',
    iconClass: 'far fa-rocket',
    navbarIndex: 0,
    component: () => import('./Steps/CreativeStep'),
    navigation: {
      back: { label: 'Back', to: 'overview' },
      next: { label: 'Next', to: 'availability' },
      skip: null,
    },
  },
  {
    name: 'availability',
    label: 'Availability',
    iconClass: 'far fa-calendar-check',
    navbarIndex: 1,
    component: () => import('./Steps/AvailabilityStep'),
    navigation: {
      back: { label: 'Back', to: 'experience' },
      next: { label: 'Next', to: 'inventory' },
      skip: null,
    },
  },
  {
    name: 'availability-create',
    label: 'Availability Create',
    iconClass: 'far fa-calendar-check',
    navbarIndex: 1,
    hideOnNavbar: true,
    component: () => import('./Steps/AvailabilityCreateStep'),
    navigation: {
      back: { label: 'Back', to: 'availability' },
      next: { label: 'Save', to: 'availability' },
      skip: null,
    },
  },
  {
    name: 'venue-create',
    label: 'Venue Create',
    iconClass: 'far fa-calendar-check',
    navbarIndex: 1,
    hideOnNavbar: true,
    component: () => import('./Steps/VenueCreateStep'),
    navigation: {
      back: { label: 'Nevermind', to: 'availability-create' },
      next: { label: 'Add Venue', to: 'venue-edit' },
      skip: null,
    },
  },
  {
    name: 'venue-edit',
    label: 'Venue Edit',
    iconClass: 'far fa-calendar-check',
    navbarIndex: 1,
    hideOnNavbar: true,
    component: () => import('./Steps/VenueEditStep'),
    navigation: {
      back: { label: 'Nevermind', to: 'availability-create' },
      next: { label: 'Save', to: 'availability-create' },
      skip: null,
    },
  },
  {
    name: 'inventory',
    label: 'Assets',
    iconClass: 'far fa-gifts',
    navbarIndex: 2,
    component: () => import('./Steps/InventoryStep'),
    navigation: {
      back: { label: 'Back', to: 'availability' },
      next: { label: 'Next', to: 'partnership' },
      skip: null,
    },
  },
  {
    name: 'inventory-create',
    label: 'Asset Create',
    iconClass: 'far fa-gifts',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/InventoryCreateStep'),
    navigation: {
      back: { label: 'Nevermind', to: 'inventory' },
      next: null,
      skip: null,
    },
  },
  {
    name: 'sampling-space-edit',
    label: 'Sampling Space Edit',
    iconClass: 'far fa-gifts',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/SamplingSpaceEditStep'),
    navigation: {
      back: { label: 'Back', to: 'inventory' },
      next: { label: 'Save', to: 'inventory' },
      skip: null,
    },
  },
  {
    name: 'onsite-space-edit',
    label: 'Onsite Space Edit',
    iconClass: 'far fa-gifts',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/OnsiteSpaceEditStep'),
    navigation: {
      back: { label: 'Back', to: 'inventory' },
      next: { label: 'Save', to: 'inventory' },
      skip: null,
    },
  },
  {
    name: 'omnichannel-space-edit',
    label: 'Omnichannel Space Edit',
    iconClass: 'far fa-phone-laptop',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/OmnichannelSpaceEditStep'),
    navigation: {
      back: { label: 'Back', to: 'inventory' },
      next: { label: 'Save', to: 'inventory' },
      skip: null,
    },
  },
  {
    name: 'sampling-venue-create',
    label: 'Venue Create',
    iconClass: 'far fa-gifts',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/VenueCreateStep'),
    navigation: {
      back: { label: 'Nevermind', to: 'sampling-space-edit' },
      next: { label: 'Add Venue', to: 'sampling-venue-edit' },
      skip: null,
    },
  },
  {
    name: 'sampling-venue-edit',
    label: 'Venue Edit',
    iconClass: 'far fa-gifts',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/VenueEditStep'),
    navigation: {
      back: { label: 'Nevermind', to: 'sampling-space-edit' },
      next: { label: 'Save', to: 'sampling-space-edit' },
      skip: null,
    },
  },
  {
    name: 'onsite-venue-create',
    label: 'Venue Create',
    iconClass: 'far fa-gifts',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/VenueCreateStep'),
    navigation: {
      back: { label: 'Nevermind', to: 'onsite-space-edit' },
      next: { label: 'Add Venue', to: 'onsite-venue-edit' },
      skip: null,
    },
  },
  {
    name: 'onsite-venue-edit',
    label: 'Venue Edit',
    iconClass: 'far fa-gifts',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/VenueEditStep'),
    navigation: {
      back: { label: 'Nevermind', to: 'onsite-space-edit' },
      next: { label: 'Save', to: 'onsite-space-edit' },
      skip: null,
    },
  },
  {
    name: 'omnichannel-venue-create',
    label: 'Venue Create',
    iconClass: 'far fa-gifts',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/VenueCreateStep'),
    navigation: {
      back: { label: 'Nevermind', to: 'omnichannel-space-edit' },
      next: { label: 'Add Venue', to: 'omnichannel-venue-edit' },
      skip: null,
    },
  },
  {
    name: 'omnichannel-venue-edit',
    label: 'Venue Edit',
    iconClass: 'far fa-gifts',
    navbarIndex: 2,
    hideOnNavbar: true,
    component: () => import('./Steps/VenueEditStep'),
    navigation: {
      back: { label: 'Nevermind', to: 'omnichannel-space-edit' },
      next: { label: 'Save', to: 'omnichannel-space-edit' },
      skip: null,
    },
  },
  {
    name: 'partnership',
    label: 'Partnership',
    iconClass: 'far fa-handshake-alt',
    navbarIndex: 3,
    component: () => import('./Steps/PartnershipStep'),
    navigation: {
      back: { label: 'Back', to: 'inventory' },
      next: { label: 'Next', to: 'preview' },
      skip: null,
    },
  },
  {
    name: 'preview',
    label: 'Preview',
    iconClass: 'far fa-clipboard-list-check',
    navbarIndex: 4,
    component: () => import('./Steps/PreviewStep'),
    navigation: {
      back: { label: 'Back', to: 'partnership' },
      finish: { label: 'Finish', to: null },
      skip: null,
    },
  },
  {
    name: 'advanced-settings',
    label: 'Advanced Settings',
    iconClass: 'fal fa-cog',
    navbarIndex: 5,
    hideOnNavbar: true,
    component: () => import('./Steps/AdvancedSettingsStep'),
    navigation: {
      back: { label: 'Back', to: 'preview' },
      next: { label: 'Save', to: 'preview' },
      skip: null,
    },
  },
]
